
import React from "react";
import { Button } from "@/components/ui/button";
import { CheckCircle, AlertCircle, Loader2 } from "lucide-react";
import { PaymentStatus } from "./types";

interface MpesaStatusProps {
  status: PaymentStatus;
  statusCheckCount: number;
  isProcessing: boolean;
  onRetry: () => void;
  onContinue: () => void;
}

const MpesaStatus: React.FC<MpesaStatusProps> = ({
  status,
  statusCheckCount,
  isProcessing,
  onRetry,
  onContinue
}) => {
  if (status === "completed") {
    return (
      <div className="py-6 space-y-4 text-center">
        <CheckCircle className="h-12 w-12 text-green-500 mx-auto" />
        <div>
          <h3 className="font-medium text-lg mb-2">Payment Successful!</h3>
          <p className="text-sm">
            Your M-Pesa payment has been completed. You will be redirected shortly.
          </p>
        </div>
      </div>
    );
  }

  if (status === "failed") {
    return (
      <div className="py-6 space-y-4 text-center">
        <AlertCircle className="h-12 w-12 text-red-500 mx-auto" />
        <div>
          <h3 className="font-medium text-lg mb-2">Payment Failed</h3>
          <p className="text-sm">
            Your M-Pesa payment could not be completed. Please try again or choose another payment method.
          </p>
        </div>
        <Button 
          onClick={onRetry} 
          className="w-full"
        >
          Try Again
        </Button>
      </div>
    );
  }

  if (status === "initiated") {
    return (
      <div className="py-6 space-y-4">
        <div className="bg-amber-50 text-amber-800 p-4 rounded-lg">
          <h3 className="font-medium mb-2">Payment Initiated</h3>
          <p className="text-sm">
            Please check your phone for the M-Pesa prompt and complete the payment.
            Once complete, you can continue to the next step.
          </p>
          {statusCheckCount >= 10 && (
            <p className="text-sm mt-2 font-medium">
              If you've completed the payment but don't see confirmation here, 
              you can continue and we'll update your account when the payment is processed.
            </p>
          )}
        </div>
        
        {isProcessing ? (
          <div className="flex justify-center">
            <Loader2 className="h-8 w-8 animate-spin text-primary" />
          </div>
        ) : statusCheckCount >= 10 ? (
          <Button 
            onClick={onContinue} 
            className="w-full"
          >
            Continue to Dashboard
          </Button>
        ) : (
          <div className="flex items-center justify-center space-x-2">
            <Loader2 className="h-4 w-4 animate-spin text-primary" />
            <span className="text-sm">Waiting for payment confirmation...</span>
          </div>
        )}
      </div>
    );
  }

  return null;
};

export default MpesaStatus;
